import React from 'react';
import PropTypes from 'prop-types';
import { XS_MOBILE, SM_MOBILE, MD_TABLET, LG_TABLET } from "../../../../../constants/textConstants";
import { connect } from "react-redux";
import { Typography, Divider } from '../../../index';
import './page_heading.scss';

const mapStateToProps = (state) => {
    return {
        screenBreakPoint: state.common.screenBreakPoint
    }
};

export const PageHeading = connect(mapStateToProps)(({
    bodyOffset = false,
    className,
    description,
    heading,
    proxyName,
    screenBreakPoint,
    righthand,
}) => {

    const isMobile = ([XS_MOBILE, SM_MOBILE, MD_TABLET, LG_TABLET]).indexOf(screenBreakPoint) > -1 ? true : false;
    const wrapRightHand = ([XS_MOBILE, SM_MOBILE, MD_TABLET]).indexOf(screenBreakPoint) > -1 ? true : false;

    const headingType = {
        [XS_MOBILE]: 'heading-05',
        [SM_MOBILE]: 'heading-05',
        [MD_TABLET]: 'heading-06',
        [LG_TABLET]: 'heading-06'
    }

    const descriptionType = {
        [XS_MOBILE]: 'body-02',
        [SM_MOBILE]: 'body-02',
        [MD_TABLET]: 'body-03',
        [LG_TABLET]: 'body-03'
    }

    const pageHeadingClasses = [
        `mybswh-page-heading`,
        `${bodyOffset ? 'mybswh-page-heading--offset' : ''}`,
        `${description ? 'mybswh-page-heading--subtext' : ''}`,
        `${righthand ? 'mybswh-page-heading--cta' : ''}`,
        `${className ? className : ''}`
    ].join(' ');

    const rightHandContent = righthand ? <div className="mybswh-page-heading__righthand">{righthand}</div> : undefined;

    return (
        <div
            className={pageHeadingClasses}
        >
            <div className="mybswh-page-heading__title">
                <h1>
                    <div className="mybswh-page-heading__title-heading">
                        <Typography
                            type={isMobile ? headingType[screenBreakPoint] : "display-01"}
                            tag="div"
                        >
                            {heading}
                        </Typography>
                        {proxyName &&
                            <Typography
                                bold
                                color="$color-secondary-a2"
                                type={"heading-02"}
                                tag="div"
                            >
                                <span>for{' '}</span>
                                <div className="mybswh-page-heading__proxy-name">
                                    {proxyName}
                                    <div className="mybswh-page-heading__proxy-name-underline" />
                                </div>
                            </Typography>
                        }
                    </div>
                </h1>
                {righthand && !wrapRightHand && rightHandContent}
            </div>
            {description &&
                <div className="mybswh-page-heading__description">
                    <Typography
                        type={isMobile ? descriptionType[screenBreakPoint] : "body-03"}
                        tag="p"
                    >
                        {description}
                    </Typography>
                </div>
            }
            {righthand && wrapRightHand && rightHandContent}
            {(description || (righthand && wrapRightHand)) &&
                <Divider
                    mLeft="none"
                    mRight="none"
                    mTop={righthand ? "xsmall" : "none"}
                    mBottom="medium"
                />
            }
        </div>
    )
});

PageHeading.propTypes = {
    bodyOffset: PropTypes.bool,
    className: PropTypes.string,
    description: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    heading: PropTypes.node,
    screenBreakPoint: PropTypes.string,
};
